import { render, staticRenderFns } from "./ContractorReviewCardNew.vue?vue&type=template&id=32cf20c5&scoped=true"
import script from "./ContractorReviewCardNew.vue?vue&type=script&lang=ts"
export * from "./ContractorReviewCardNew.vue?vue&type=script&lang=ts"
import style0 from "./ContractorReviewCardNew.vue?vue&type=style&index=0&id=32cf20c5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cf20c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32cf20c5')) {
      api.createRecord('32cf20c5', component.options)
    } else {
      api.reload('32cf20c5', component.options)
    }
    module.hot.accept("./ContractorReviewCardNew.vue?vue&type=template&id=32cf20c5&scoped=true", function () {
      api.rerender('32cf20c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyContractors/ContractorReviewCardNew.vue"
export default component.exports